import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function DownloadTyc() {
  const navigate = useNavigate();

  useEffect(() => {
    const downloadPdf = async () => {
      try {
        // URL pública del archivo PDF
        const pdfUrl = `${process.env.PUBLIC_URL}/assets/pdf/tyc.pdf`;
        
        // Crear un enlace temporal para descargar el archivo
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "terminos-y-condiciones.pdf";
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Redirigir de vuelta después de un breve delay
        setTimeout(() => {
          navigate(-1);
        }, 100);
      } catch (error) {
        console.error("Error al descargar el archivo:", error);
        navigate(-1);
      }
    };

    downloadPdf();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p>Descargando archivo...</p>
    </div>
  );
} 